import { getSelectedTableView, TableQueryType } from 'owa-mail-list-store';
import { isPublicFolder } from 'owa-folders';

/**
 * Checks if selected row in left nav is public folder
 */
export function isPublicFolderSelected(): boolean {
    const selectedTable = getSelectedTableView();
    return (
        selectedTable &&
        selectedTable.tableQuery.type == TableQueryType.Folder &&
        isPublicFolder(selectedTable.tableQuery.folderId)
    );
}

/**
 * Gets folderId from a specified row in left nav
 */
export function getSelectedPublicFolderId(): string {
    const tableView = getSelectedTableView();
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (24,5): Type 'string | null' is not assignable to type 'string'.
    // @ts-expect-error
    return tableView &&
        tableView.tableQuery.type == TableQueryType.Folder &&
        isPublicFolder(tableView.tableQuery.folderId)
        ? tableView.tableQuery.folderId
        : null;
}
